// extracted by mini-css-extract-plugin
export default {"form":"Fo","inline":"Go","inputWrapper":"Ho","input":"Io","withoutLabel":"Jo","error":"Ko","label":"Lo"};